<template>
    <v-container fill-height class="align-center">
        <v-row class="justify-space-between pa-4 absolute-top align-center" no-gutters>
            <v-col>
                <div class="text-left">
                    <v-img
                        alt="logo"
                        src="/svg/logo.svg"
                        class="align-self-start mb-1"
                        width="150"
                        contain
                    ></v-img>
                </div>

                <div class="d-sm-flex d-block mx-auto" id="level">
                    <div id="gears">
                        <v-img src="/images/gears.gif" />
                    </div>
                    <div id="title" class=" text-center d-sm-inline-block">
                        <h1>Oops!</h1>
                        <h2>Kaoshi is down for maintenance</h2>
                        <p class="title font-weight-bold">Please check again later</p>
                    </div>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    mounted() {
        Vue.backendApi().countries().list().then(() => { // just dummy request
            this.$router.push('/');
        }, (err) => {
            console.log(err);
        });
    },
};
</script>

<style scoped>
#title h1{
	font-size: 3.6em;
	text-shadow: rgba(0, 0, 0, 0.36) 7px 7px 10px;
    color: #181235;
}

#title p{
	line-height: 148%;
}

#gears img {
    height: 350px;
}

@media screen and (min-width: 960px) {
    #level {
        width: 100%;
        height: 1px;
        position: absolute;
        top: 20%;
        left: 15%;
    }

    #title{
        width: 43%;
        margin-top: 5em;
    }

    #gears img {
        height: 450px;
    }

}
</style>